/* eslint-disable */
<template>
	<section>
		<div class="smaller-heading">Zeitraum wählen</div>
		<div class="text">
			<p>Wählen Sie Ihren Anreise- und Abreisetag</p>
		</div>
		<div class="date_wrapper">
			<input id="datepicker-inline-trigger" type="text" placeholder="Select date">
			<airbnb-style-datepicker
				:trigger-element-id="'datepicker-inline-trigger'"
				:mode="'range'"
				:inline="true"
				:date-one="arrival_date"
				:date-two="departure_date"
				:show-action-buttons="false"
				:min-date="'2018-04-18'"
				:fullscreen-mobile="false"
				:months-to-show="2"
				@date-one-selected="firstDateChange"
				@date-two-selected="lastDateChange"
				style="width:1000px;    margin: 0 auto;"
			/>
		</div>

		<div class="button_wrapper">
			<router-link :to="{ name: 'details'}">
				<button class="button">Weiter</button>
			</router-link>
		</div>
	</section>
</template>
<script>
import format from 'date-fns/format'

export default {
	name: 'DateSelect',

	components: {},
	computed: {
		arrival_date: {
			get () {
				return this.$store.state.booking.arrival_date
			},
			set (value) {
				console.log('sttttt')
				this.$store.commit('arrivalUpdate', value)
			}
		},
		departure_date: {
			get () {
				return this.$store.state.booking.departure_date
			},
			set (value) {
				console.log('sttttt')
				this.$store.commit('departureUpdate', value)
			}
		}
	},
	data () {
		return {
			dateFormat: 'YYYY-MM-DD', // 'D MMM',
			buttonDateOne: '',
			buttonDateTwo: '',
			sundayFirst: false,
			showDatepickers: true,
			trigger: false,

			companies: [{ test: 'test' }]
		}
	},

	created () {
		// this.fetchData();
	},

	// watch: {
	//   $route: "fetchData"
	// },

	methods: {
		firstDateChange (val) {
			this.arrival_date = val
		},
		lastDateChange (val) {
			this.departure_date = val
		},
		formatDates (dateOne, dateTwo) {
			let formattedDates = ''
			if (dateOne) {
				formattedDates = format(dateOne, this.dateFormat)
			}
			if (dateTwo) {
				formattedDates += ' - ' + format(dateTwo, this.dateFormat)
			}
			return formattedDates
		}
	}
}
</script>
<style >
.smaller-heading {
	margin-top: 0;
}
.date_wrapper {
	margin-top: 3em;
}
.button_wrapper {
	text-align: center;
	position: absolute;
	left: 0;
	right: 0;
	bottom: 3em;
}
.smaller-heading {
	font-size: 5em;
	font-weight: 900;
	text-align: center;
	margin-top: 1em;
}

.text {
	font-size: 1.5em;
	text-align: center;
	margin: 0em;
}
#datepicker-inline-trigger {
	display: none;
}
.asd__month {
	width: 500px !important;
}
.asd__inner-wrapper {
	margin-left: -500px !important;
}
.asd__days-legend {
	width: 500px !important;
}
.asd__days-legend:last-of-type {
	left: 500px !important;
}
.asd__day {
	height: 60px;
	line-height: 60px;
	font-size: 30px;
}
.asd__day-button {
	font-size: 25px !important;
}
.asd__day--enabled {
	border: 1px solid #636e7294;
}
.asd__month-table {
	background: transparent;
}
.asd__wrapper {
	background-color: transparent;
	border: 0;
}
.asd__change-month-button {
	background: transparent;
}

.asd__change-month-button > button {
	background-color: #d2292a;
	border: 0;
}

.asd__change-month-button > button > svg {
	fill: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/DateSelect.vue